import {CacheEventBus} from "src/core/common/cache";
import EventBus from "src/core/common/eventBus";
import debounce from "lodash/debounce";

export const refresh = debounce(() => {
  CacheEventBus.notify({tag: "products", operation: "invalidate"});
  eventBus.notify();
}, 300);
export const eventBus = new EventBus();
